import React from 'react'

export default () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3108_3862)">
        <rect width="44" height="44" fill="white" />
        <rect width="44" height="44" fill="#032942" />
        <g>
          <path
            d="M11.25 -2.17483L13.375 -8.97483L48.65 -11.9498L48.225 -2.17483L42.7 2.50017H35.475L27.825 10.5752L11.25 -2.17483Z"
            fill="#33C3F0"
            fillOpacity="0.35"
            stroke="#33C3F0"
          />
          <path
            d="M21.4502 24.6002L30.3752 13.1252L41.0002 22.9002L34.2002 33.5252L21.4502 24.6002Z"
            fill="#FF5631"
            fillOpacity="0.35"
            stroke="#FF5631"
          />
          <path
            d="M24.425 26.7252L16.775 21.2002L7 33.1002L15.5 38.6252L24.425 26.7252Z"
            fill="#FF5631"
            fillOpacity="0.35"
            stroke="#FF5631"
          />
          <path
            d="M6.5752 29.2752L-8.2998 17.3752V25.8752L2.7502 33.9502L6.5752 29.2752Z"
            fill="#FCE61E"
            fillOpacity="0.35"
            stroke="#FCE61E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3108_3862">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
